module.exports = __webpack_public_path__ + "static/media/bg-header.4f4bb1f3.png";